// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// The product rail scrolls natively on touch. On a pointer device it can also be
// dragged, and the click that ends a drag must not open the product underneath.
(() => {
  const DRAG_START = 4;

  const init = (rail) => {
    if (rail.dataset.spCarousel) return;
    rail.dataset.spCarousel = 'on';

    let active = false;
    let startX = 0;
    let startScroll = 0;
    let distance = 0;

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      active = true;
      distance = 0;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', (event) => {
      if (!active) return;
      const dx = event.clientX - startX;
      distance = Math.abs(dx);
      if (!rail.classList.contains('is-dragging')) {
        if (distance < DRAG_START) return;
        rail.classList.add('is-dragging');
        try { rail.setPointerCapture(event.pointerId); } catch (e) { /* capture is a nicety */ }
      }
      rail.scrollLeft = startScroll - dx;
      event.preventDefault();
    });

    const release = (event) => {
      if (!active) return;
      active = false;
      try { rail.releasePointerCapture(event.pointerId); } catch (e) { /* already gone */ }
      if (!rail.classList.contains('is-dragging')) return;
      rail.classList.remove('is-dragging');
      if (distance <= DRAG_START) return;
      const swallow = (click) => { click.preventDefault(); click.stopPropagation(); };
      rail.addEventListener('click', swallow, { capture: true, once: true });
      setTimeout(() => rail.removeEventListener('click', swallow, true), 120);
    };

    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('dragstart', (event) => event.preventDefault());
  };

  const boot = () => document.querySelectorAll('.sp-carousel').forEach(init);
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
